import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Loader } from '@googlemaps/js-api-loader';
import { DataService } from './data.service';
import { MapProperties } from '../http/mapProperties';
import { CssService } from './css.service';

@Injectable({
    providedIn: 'root'
})
export class MapService {

    map!: google.maps.Map;
    service!: google.maps.places.PlacesService;
    addressName?: string;
    marker!: google.maps.Marker;
    canSetAddress = true;
    mapProperties: MapProperties[]
    showMapLabel = ""
    root: any;

    constructor(private dataService: DataService, @Inject(DOCUMENT) private document: Document, private agent: CssService) {
        this.mapProperties = [];
        const app = document.getElementsByTagName('app-q11bot')[0];
        this.root = app.shadowRoot ? app.shadowRoot : this.document

        const loader = new Loader({
            apiKey: 'AIzaSyAmJFR5Q-rQfBKU94UlF02WWh7GLari-IE',
            version: '3',
            libraries: ['places']
        });
        loader.importLibrary('maps')
            .then(({ Map }) => {
                const mapElement = this.root.getElementById('q11-chat-map');
                const mapOptions = {};
                if (mapElement) new Map(mapElement, mapOptions);
            })
            .catch((e) => {
                console.log('Error in loading googlemaps' + e);
            });
    }

    // addMirroredMapProperties(mapElement: any, map?: google.maps.Map) {
    //     const mapIndex = Number(mapElement.className[mapElement.className.indexOf('index') + 5])
    //     const currMap = this.mapProperties[mapIndex]
    //     if (map) {
    //         currMap.map = map
    //     }
    //     if (currMap.type == "set-address") {
    //         if (currMap.erasemarker) {
    //             currMap.marker!.setMap(null)
    //         }
    //         const position = currMap.marker!.getPosition()
    //         currMap.marker = new google.maps.Marker({
    //             map: currMap.map,
    //             position: position ? { lat: position.lat(), lng: position.lng() } : undefined,
    //         });
    //         const newInfowindow = new google.maps.InfoWindow({
    //             content: currMap.infowindow!.getContent()
    //         });
    //         newInfowindow.open(currMap.map, currMap.marker)
    //         currMap.map!.setCenter({ lat: currMap.centerLat!, lng: currMap.centerLng! })
    //         currMap.marker = currMap.marker
    //         currMap.erasemarker = true
    //     } else if (currMap.type == "directions") {
    //         const directionsRenderer = new google.maps.DirectionsRenderer();
    //         directionsRenderer.setMap(currMap.map!);
    //         directionsRenderer.setDirections(currMap.directionsresponse!)
    //     } else if (currMap.type == "map") {
    //         const newInfowindow = new google.maps.InfoWindow({
    //             content: currMap.infowindow!.getContent()
    //         });            
    //         const position = currMap.marker!.getPosition()
    //         currMap.marker = new google.maps.Marker({
    //             map: currMap.map,
    //             position: position ? { lat: position.lat(), lng: position.lng() } : undefined,
    //         });
    //         newInfowindow.open(currMap.map, currMap.marker)
    //         currMap.map!.setCenter({ lat: currMap.centerLat!, lng: currMap.centerLng! })  
    //         currMap.marker = currMap.marker
    //         currMap.erasemarker = true  
    //     }
    // }

    checkMap(mapIndex: any, map: google.maps.Map, mapElement: any, allResponseType: string[], allResponseInfoArray: { [key: string]: string }[][]) {
        for (let i = 0; i < allResponseType.length; i++) {
            if (allResponseType[i] == 'map-card') {
                this.map = this.createMap(mapElement, mapIndex)
                if (allResponseInfoArray[i][0]['type'] == 'set-address') {
                    this.setAddress(this.map, this.dataService.mapIndex)

                } else if (allResponseInfoArray[i][0]['type'] == 'directions') {
                    this.setDirections(this.map, allResponseInfoArray[i][0], this.dataService.mapIndex)
                } else if (allResponseInfoArray[i][0]['type'] == 'map') {
                    this.centerMap(this.map, this.dataService.mapIndex, allResponseInfoArray[i][0])
                }
                this.dataService.updateMapIndex(mapIndex)
            }
        }
    }

    centerMap(map: any, mapIndex: any, results: any) {
        const address = this.addressFromURL(results['google-url'])
        const geocoder = new google.maps.Geocoder();
        if (!address[1]) {
            geocoder.geocode({ 'address': address[0] }, (results, status) => {
                if (status === "OK" && results) {
                    const place = results[0]
                    map.setCenter(place.geometry.location)
                    map.setZoom(15)

                    if (this.mapProperties[mapIndex].marker) {
                        this.mapProperties[mapIndex].marker!.setMap(null)
                    }

                    this.marker = new google.maps.Marker({
                        map: map,
                        position: place.geometry!.location,
                    });
                    const labelContent = '<bdi' +
                        'style="font-weight: bold; font-size: 10px !important; background-color: rgba(0, 0, 0, 0.5); color: black;  border-radius: 5px;">' +
                        place.formatted_address! +
                        '</bdi>';
                    const infowindow = new google.maps.InfoWindow({
                        content: labelContent
                    });
                    infowindow.open(map, this.marker);
                    this.mapProperties[mapIndex].infowindow = infowindow
                    this.mapProperties[mapIndex].centerLat = place.geometry!.location.lat()
                    this.mapProperties[mapIndex].centerLng = place.geometry!.location.lng()
                    this.mapProperties[mapIndex].marker = this.marker
                    this.mapProperties[mapIndex].erasemarker = false
                    this.mapProperties[mapIndex].type = "map"

                } else {
                    if (this.agent.properties?.coordinates) {
                        map.setCenter({ lat: this.agent.properties.coordinates[0], lng: this.agent.properties.coordinates[1] })
                    } else {
                        map.setCenter({ lat: 49.000379, lng: -101.369967 })
                    }
                }
            });
        } else {
            const coords = address[0]!.split(',');

            if (coords.length !== 2) {
                console.error('Invalid coordinate format. Expected format: "lat,lng"');
                return
            }

            const lat = parseFloat(coords[0].replace(/[^0-9.-]+/g, ''));
            const lng = parseFloat(coords[1].replace(/[^0-9.-]+/g, ''));
            let newCoords = new google.maps.LatLng(lat, lng)
            map.setCenter(newCoords)
            map.setZoom(15)
            if (this.mapProperties[mapIndex].marker) {
                this.mapProperties[mapIndex].marker!.setMap(null)
            }

            this.marker = new google.maps.Marker({
                map: map,
                position: newCoords,
            });
            this.mapProperties[mapIndex].centerLat = newCoords.lat()
            this.mapProperties[mapIndex].centerLng = newCoords.lng()
            this.mapProperties[mapIndex].marker = this.marker
            this.mapProperties[mapIndex].erasemarker = false
            this.mapProperties[mapIndex].type = "map"
        }
    }

    // createMirroredMap(mapElement: any) {
    //     const mapProperties = {
    //         center: new google.maps.LatLng(49.000379, -101.369967),
    //         zoom: 15,
    //         mapTypeId: google.maps.MapTypeId.ROADMAP,
    //         disableDefaultUI: true,
    //         zoomControl: true,
    //         scrollwheel: false,
    //         controlSize: 20,
    //     };
    //     if (this.agent.properties?.coordinates) {
    //         mapProperties.center = new google.maps.LatLng(this.agent.properties.coordinates[0], this.agent.properties.coordinates[1])
    //         mapProperties.zoom = 15
    //     }
    //     const map = new google.maps.Map(mapElement, mapProperties);
    //     this.addMirroredMapProperties(mapElement, map)
    // }

    createMap(mapElement: any, mapIndex: any) {
        const mapProperties = {
            center: new google.maps.LatLng(49.000379, -101.369967),
            zoom: 2,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: false,
            controlSize: 20,
        };
        var mP: MapProperties = {
            centerLat: 49.000379,
            centerLng: -101.369967,
        }

        if (this.agent.properties?.coordinates) {
            mapProperties.center = new google.maps.LatLng(this.agent.properties.coordinates[0], this.agent.properties.coordinates[1])
            mapProperties.zoom = 15
            mP.centerLat = this.agent.properties.coordinates[0]
            mP.centerLng = this.agent.properties.coordinates[1]
        }

        this.mapProperties.push(mP)
        return new google.maps.Map(mapElement.nativeElement, mapProperties)
    }

    setAddress(map: any, mapIndex: any) {
        if (!this.canSetAddress) {
            return
        }
        this.canSetAddress = false
        let classInput = ".pac-input-text.index" + mapIndex
        let classContainer = ".search-container.index" + mapIndex

        const inputList = this.root.querySelectorAll(classInput);
        const input = inputList.item(inputList.length - 1) as HTMLInputElement

        const containerList = this.root.querySelectorAll(classContainer);
        const container = containerList.item(containerList.length - 1) as HTMLElement

        container.setAttribute("style", "content-visibility: visible")
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(container);

        this.map = map

        const options = {
            fields: ["formatted_address", "geometry"],
            // strictBounds: false,
        };

        const autoComp = new google.maps.places.Autocomplete(input, options);
        setTimeout(() => {
            this.addContainer(container)
        }, 1000)

        autoComp.addListener("place_changed", () => {
            // container.setAttribute("style", "visibility: hidden")

            const place = autoComp.getPlace();
            map.setZoom(15)
            const bounds = new google.maps.LatLngBounds();

            if (!place.geometry || !place.geometry.location) {
                console.log("Returned place contains no geometry");
                return;
            }

            if (this.mapProperties[mapIndex].marker) {
                this.mapProperties[mapIndex].marker!.setMap(null)
            }

            this.marker = new google.maps.Marker({
                map: map,
                position: place.geometry!.location,
            });
            const labelContent = '<bdi' +
                'style="font-weight: bold; font-size: 10px !important; background-color: rgba(0, 0, 0, 0.5); color: black;  border-radius: 5px;">' +
                place.formatted_address! +
                '</bdi>';
            const infowindow = new google.maps.InfoWindow({
                content: labelContent
            });
            infowindow.open(map, this.marker);
            this.mapProperties[mapIndex].infowindow = infowindow
            this.mapProperties[mapIndex].centerLat = place.geometry!.location.lat()
            this.mapProperties[mapIndex].centerLng = place.geometry!.location.lng()
            this.mapProperties[mapIndex].marker = this.marker
            this.mapProperties[mapIndex].erasemarker = false
            this.mapProperties[mapIndex].type = "set-address"
            this.dataService.askType = "confirmed-address"
            this.dataService.confirmAddress = place.formatted_address!
            this.dataService.isTyping = false
            map.setCenter(place.geometry!.location!);
        });
    }

    addContainer(container: any) {
        const pacContainerList = document.querySelectorAll('.pac-container')
        if (pacContainerList) {
            Array.prototype.slice.call(pacContainerList).forEach((pac: HTMLElement) => {
                if (pac.parentNode == document.body) {
                    container.appendChild(pac)
                    this.canSetAddress = true
                }
            })
        } else {
            setTimeout(() => {
                this.addContainer(container)
            }, 500)
        }
    }

    setDirections(map: any, info: { [key: string]: string }, mapIndex: number) {
        const directionsService = new google.maps.DirectionsService();
        const directionsRenderer = new google.maps.DirectionsRenderer();

        directionsRenderer.setMap(map);

        directionsService.route({
            origin: info['fromaddress'],
            destination: info['toaddress'],
            travelMode: google.maps.TravelMode.DRIVING,
        }, (response, status) => {
            if (status == 'OK') {
                directionsRenderer.setDirections(response);
                this.mapProperties[mapIndex].directionsrenderer = directionsRenderer
                this.mapProperties[mapIndex].directionsresponse = response!
                this.mapProperties[mapIndex].type = 'directions'
            } else {
                window.alert('Directions request failed due to ' + status);
            }
        });
    }

    addressFromURL(url: string): [string | null, boolean] {
        //query
        const placeIndex = url.indexOf('/place/');
        const searchIndex = url.indexOf('/search/')
        const destination = url.indexOf('destination')
        const coordinatesTest = /(-?\d+(\.\d+)?),(-?\d+(\.\d+)?)/
        const match = url.match(coordinatesTest);
        if (match) {
            return [match[0], true]
        }
        if (placeIndex === -1 && searchIndex === -1 && destination === -1) {
            return [null, false];
        } else if (placeIndex !== -1) {
            const addressPart = url.split('/place/')[1];
            return [addressPart.replace(/\+/g, ' '), false];
        } else if (searchIndex !== -1) {
            let addressPart = url.split('/search/')[1];
            addressPart = addressPart.replace(/\+/g, ' ');
            return [addressPart, false]
        } else if (destination !== -1) {
            const addressPart = url.split('destination=')[1];
            return [addressPart.replace(/\+/g, ' '), false];
        }
        return [null, false]
    }
}
